import { useTranslation } from 'react-i18next';
import { getWeightLabel } from '../../data';
import { useBuilderContext } from '../../context/BuilderContext';

export function CampaignWeightSection() {
  const { t } = useTranslation();
  const { form, setForm } = useBuilderContext();
  const w = form.campaignWeight;
  const boost = form.boostUrgente;
  const boostDays = form.boostDays;

  return (
    <div className="builder-section">
      <div className="cfg-section-head">
        <div>
          <h3>
            <i className="fas fa-star" /> {t('admin.builderCampaignWeight')}{' '}
            <span className="cfg-admin-tag">{t('admin.builderAdminGlobalOnly')}</span>
          </h3>
          <p className="cfg-section-sub">{t('admin.builderCampaignWeightSub')}</p>
        </div>
      </div>
      <div className="form-group">
        <label className="cfg-label">{t('admin.builderWeightBase')}</label>
        <div className="weight-input-container">
          <input
            type="range"
            className="weight-slider"
            min={1}
            max={10}
            value={w}
            style={{ '--val': `${(w - 1) / 9 * 100}%` } as React.CSSProperties & { '--val': string }}
            onChange={e => setForm(p => ({ ...p, campaignWeight: parseInt(e.target.value) }))}
          />
          <div className="weight-display">
            <span className="weight-value">{w}</span>
            <span className="weight-label">{getWeightLabel(w, t)}</span>
          </div>
        </div>
      </div>
      <div className="cfg-divider" />
      <div className="cfg-boost-row">
        <div className="cfg-boost-left">
          <span className="cfg-boost-icon"><i className="fas fa-bolt" style={{ color: '#F08521' }} /></span>
          <div>
            <div className="cfg-boost-title">{t('admin.builderBoostUrgent')}</div>
            <div className="cfg-boost-desc">{t('admin.builderBoostUrgentSub')}</div>
          </div>
        </div>
        <label className="cfg-toggle">
          <input
            type="checkbox"
            checked={boost}
            onChange={e => setForm(p => ({ ...p, boostUrgente: e.target.checked }))}
          />
          <span className="cfg-toggle-track" />
        </label>
      </div>
      {boost && (
        <div className="form-group cfg-boost-days-group">
          <label className="cfg-label">
            {t('admin.builderBoostDays')}{' '}
            <input
              type="number"
              className="cfg-inline-input"
              min={1}
              max={30}
              value={boostDays}
              onChange={e => setForm(p => ({ ...p, boostDays: parseInt(e.target.value) || 1 }))}
            />{' '}
            {t('admin.builderBoostDays')}
          </label>
        </div>
      )}
      <div className={`cfg-boost-status${boost ? ' active' : ''}`}>
        <i className={`fas fa-${boost ? 'fire' : 'circle'}`} />
        {boost
          ? <> {t('admin.builderBoostActiveMsg')} <strong>{boostDays} {boostDays !== 1 ? t('admin.builderBoostDays') : t('admin.builderBoostActiveDays')}</strong></>
          : <> {t('admin.builderNoBoostMsg')}</>
        }
      </div>
    </div>
  );
}
